import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import KYCUserListPageUI from './KYCUserListPageUI.js'

class KYCUserListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      accountUserList: null,
      copyToClipboardText: null,
      createUserMode: false,
      createDirectorMode: false,
    }
  }

  render() {
    return (
      <KYCUserListPageUI
        context={this.props.context}
        account={this.state.account}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        accountUserList={this.state.accountUserList}
        onRefreshClick={this.onRefreshClick}
        createUserMode={this.state.createUserMode}
        createDirectorMode={this.state.createDirectorMode}
        onCreateUserClick={() => {this.setState({'createUserMode': true})}}
        onCancelCreateUser={() => {this.setState({'createUserMode': false})}}
        onCreateDirectorClick={() => {this.setState({'createDirectorMode': true})}}
        onCancelCreateDirector={() => {this.setState({'createDirectorMode': false})}}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getAccountUsers(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({account : response.account})
  }

  onCopyToClipboard = (text, result) => {
    this.setState({copyToClipboardText: text})
    setTimeout(() => {
      this.setState({copyToClipboardText: null})
    }, 3000)
  }

  getAccountUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/users`,
      cacheKey: CacheKeys.AccountUsers(this.props.match.params.accountId),
      callback: this.getAccountUsersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountUsersCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      accountUserList : response.accountUserList,
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Accounts(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.AccountUsers(this.props.match.params.accountId))
    if (noBusy === 'noBusy') {
      this.getAccounts(context)
      this.getAccountUsers(context)
    }
    else
      this.setState({account: null, accountUserList: null}, () => {
        this.getAccounts(context)
        this.getAccountUsers(context)
      })
  }
}

export default withRouter(KYCUserListPageSF)
